/**
 * @description 旅遊警示用
*/
export enum WarnStatus {
  /** 無警示 */
  None = '0',
  /** 灰色警示-提醒注意 */
  Gray = '1',
  /** 黃色警示-特別注意旅遊安全並檢討應否前往 */
  Yellow = '2',
  /** 橙色警示-避免非必要旅行 */
  Orange = '3',
  /** 紅色警示-不宜前往，宜儘速離境 */
  Red = '4'
};
